import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import { SessionContext } from "@context/SessionContext";
import { UserContext } from "@context/UserContext";

export const CheckoutComplimentaryContext = createContext({});

const CheckoutComplimentaryContextProvider = (props) => {
    const { isLoggedIn } = useContext(AuthContext);
    const { setPurchasedTicket, setPurchasedSession } = useContext(UserContext);
    const { session } = useContext(SessionContext);
    const [error, setError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { children } = props;

    const checkoutComplementary = (uuid) => {
        setIsSubmitting(true);
        axios
            .post(`${API_BASE_URL}/ticket/promo-result/${uuid}`)
            .then(function (response) {
                if (response.status === 201) {
                    setIsSubmitting(false);
                    setPurchasedSession(session);
                    setPurchasedTicket(response.data.data.ticket);

                    // Cinema bookings have their own success page; the ticket one has no booking to show.
                    window.open(
                        response.data.data.is_voucher_to_ticket
                            ? `/success_book_with_cinema?id=${uuid}`
                            : `/ticket/success/${uuid}`,
                        "_self"
                    );
                } else {
                    const message = response.data.errors
                        ? response.data.errors[0].desc
                        : "Payment failed, Please try again";
                    setError(message);
                }
            })
            .catch((error) => {
                if (isLoggedIn && error?.response?.status === 401) {
                    window.location = "/";
                }

                setIsSubmitting(false);
                const message = error?.response?.data?.errors
                    ? error?.response?.data?.errors[0]?.desc
                    : error?.response?.data?.message;
                setError(message);
            });
    };

    return (
        <CheckoutComplimentaryContext.Provider
            value={{
                isSubmitting,
                error,
                checkoutComplementary,
            }}
        >
            {children}
        </CheckoutComplimentaryContext.Provider>
    );
};

export default CheckoutComplimentaryContextProvider;

